import { css } from '@emotion/react';

import { cookieBotStyles } from './cookiebot-style';
import { colors } from './colors';
import { fonts } from './fonts';

export const globalStyles = css`
  ${fonts};
  ${cookieBotStyles}

  html[data-mobile-menu-open='true'],
  html[data-mobile-menu-open='true'] body {
    background-color: ${colors.components.fixedTop.Background.Open};
  }

  /*
    This will hide the focus indicator if the element receives focus via the mouse,
    but it will still show up on keyboard focus.
  */
  :focus:not([data-focus-visible-added]) {
    outline: none;
  }

  html[data-auth-logged-in='true'] [data-auth-logout-placeholder] {
    display: inline-block !important;
  }

  html[data-auth-logged-in='true'] [data-auth-login-placeholder] {
    display: none !important;
  }

  dd,
  dd,
  dt {
    margin: 0;
  }

  h1,
  h2,
  h3,
  h4 {
    hyphens: auto;
    overflow-wrap: anywhere;
    word-break: normal;
  }
`;
